<template lang="pug">
    app-dialog(v-model="$_show" :header="headerText" :confirm-text="confirmText" :confirm-disabled="isNotReady" @confirm="sign" width="756")
      v-form(ref="signForm" v-model="valid")
         app-select(v-if="certList.length > 0" v-model="cert" :items="certList" label="Выберите сертификат" item-text="text" :rules="[rules.required]")
         app-button(v-else) Средства криптографии не установлены

      template(slot="footer" v-if="doc!=null && doc.deliveryStatus.name=='RECEIVED'")
         .sud-dialog-card__footer
             app-button-action.mr-2(v-if="part!=null && sigId!=null" @click="verify" :dark="valid" :disabled="!valid") Проверить подпись
             app-button-action.mr-0(v-else-if="part!=null" @click="sign" :dark="valid" :disabled="!valid") Просмотреть документ
              
            
</template>

<script>
import { AppDialogToggable } from '@/components'
import {$_sign} from './sign'
import { $_validate_rules } from '@/common/ValidateRules'
import { docService } from '@/_services'

export default {
  mixins: [AppDialogToggable, $_sign, $_validate_rules],
  props: {
    doc: null,
    part: null,
    sigId: null,
  },
  data () {
    return {
      valid: false,
      isCarmaInit: false,
      cert: null,
      certList: []
    }
  },
  methods: {
    send(text, step) {
      let canSend = false;

      if( this.doc.sendChannel.name=="EMAILCRYPT" ){
        if( step=="ENC" ) canSend=true
      } else canSend=true

      if(canSend){
        docService.send(this.doc.id)
        .then(() => this.$emit('sended', text))
      }
    },
    notsend(text) {
      this.$emit('sendfail', text)
    },
    ok(text) {
      this.$emit('ok', text)
    },
    carmaInit () {
      this.isCarmaInit=true
    },
    verify() {
      if (this.$refs.signForm.validate() && this.cert!=null) 
          if (this.doc.deliveryStatus.name=='RECEIVED'){ 
             this.$sign_setOk(this.ok)
             this.$sign_setFail(this.notsend)
             this.$_show = false
             this.$sign_verifyEncResponse(this.part.partId, this.sigId, this.cert.value)
          }
    },
    sign() {
      let cc = this.$sign_certInfo(this.cert.value)
      let sigData = {}
      sigData.sn=cc.Serial
      sigData.dateFrom=cc.ValidFrom.getTime()
      sigData.dateTo=cc.ValidTo.getTime()  
      sigData.cn=cc.SubjectTags.split('\r\n').filter(t => t.indexOf("CN=")!=-1)[0].substring(3)

      docService.setSigData(this.doc.id, sigData) 
      .then(() => this.directlySign())
    },
    directlySign() {
      if (this.$refs.signForm.validate() && this.cert!=null) {
          this.$sign_setOk(this.send)
          this.$sign_setFail(this.notsend)

          if (this.doc.deliveryStatus.name=='RECEIVED') {
             this.$_show = false
             this.$sign_viewResponse(this.part, this.cert.value)
          } else {
             if(this.doc.sendChannel.name=="EMAILCRYPT" && this.doc.sendable.organization)
                this.$sign_signandcryptFileFunction(this.doc.id, this.cert.value, this.doc.sendable.organization.id)
             else if(this.doc.sendChannel.name=="SMIME") {
                if(this.doc.sendable.organization)
                    this.$sign_signandcryptSmimeFunction(this.doc.id, this.cert.value, this.doc.sendable.organization.id)
                else 
                    this.$sign_signSmimeFunction(this.doc.id, this.cert.value)
             } else 
                this.$sign_signFileFunction(this.doc.id, this.cert.value)
          }
      }
    }
  },
  computed: {
    isNotReady () {
      return !this.valid
    },
    confirmText() {
      let txt= (this.doc!=null && this.doc.deliveryStatus.name=='RECEIVED')? "Просмотреть" : "Подписать"
      return (this.certList.length > 0) ? txt : ""
    },
    headerText() {
      return (this.doc!=null && this.doc.deliveryStatus.name=='RECEIVED')? "Просмотреть полученный документ" : "Подписать документ"
    }
  },
  watch: {
    isCarmaInit (value) {
      if (value) this.certList = this.$sign_loadFunction()
    },
  },
  created() {
    this.$sign_carmaInit(this.carmaInit)
  }
}
</script>

<style lang="scss" scoped>

.sud-dialog-card__footer {
  text-align: right;
  padding-top: 16px;
}

</style>

